<template>
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1"
         xmlns:xlink="http://www.w3.org/1999/xlink"
         class="line"
         :width="width"
         :height="height"
         :viewBox="`0 0 ${width} ${height}`">
        <rect :width="width" :height="height" :class="color"></rect>
    </svg>
</template>

<script>
    import SVGMixin from './svg.mixin'

    export default {
        name: "LineSvg",
        mixins: [SVGMixin],
        props: {
            color: {
                type: String,
                default: 'blue-stroke',
                required: false
            },
            hoverOn: {
                type: Boolean,
                default: false
            },
            width: {
                type: Number,
                default: 50
            },
            height: {
                type: Number,
                default: 1
            }
        },
        computed: {
            hoverClass() {
                if (!this.hoverOn) return '';

                return `${this.color}-hover`;
            }
        }
    }
</script>

<style lang="scss">
    .white-stroke {
        stroke: $white;
    }

    .blue-stroke {
        stroke: $color1;
    }
</style>